import React from 'react';
import { Card, CardHeader, Divider, CardContent, Grid, Box, Typography } from '@mui/material';
import JobStatusIndicator from '../../../features/patches/components/JobStatusIndicator';
import { MenuViewer } from '../Menu';
import { Store } from '../../../types';

interface Step4PublishAndReviewProps {
  jobStatus: any;
  menuJobStatus: any;
  isMenuJobPolling: boolean;
  selectedStores: Store[];
  submitError: string | null;
  isSubmitting: boolean;
  success: boolean;
}

const Step4PublishAndReview: React.FC<Step4PublishAndReviewProps> = ({
  jobStatus,
  menuJobStatus,
  isMenuJobPolling,
  selectedStores,
  submitError,
  isSubmitting,
  success,
}) => (
  <Card>
    <CardHeader title='Publish & Review' />
    <Divider />
    <CardContent>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box sx={{ mb: 3 }}>
            <Typography variant='h6' gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              1. Publishing Patch Changes
              {jobStatus?.status === 'COMPLETED' && (
                <Typography color='success.main' component='span'>✓</Typography>
              )}
            </Typography>
            <JobStatusIndicator
              status={jobStatus?.status}
              progress={jobStatus?.progress}
              total={jobStatus?.total}
              error={submitError}
              isSubmitting={isSubmitting}
              success={success}
              type="patch"
              totalSubJobs={jobStatus?.totalSubJobs}
              totalSubJobsCompleted={jobStatus?.totalSubJobsCompleted}
              totalSubJobsFailed={jobStatus?.totalSubJobsFailed}
              totalSubJobsInProgress={jobStatus?.totalSubJobsInProgress}
              startedAt={jobStatus?.startedAt}
              completedAt={jobStatus?.completedAt}
            />
          </Box>

          <Box sx={{ mb: 3 }}>
            <Typography variant='h6' gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              2. Publishing Menu Changes
              {!isMenuJobPolling && menuJobStatus?.status === 'COMPLETED' && (
                <Typography color='success.main' component='span'>✓</Typography>
              )}
            </Typography>
            {jobStatus?.status === 'COMPLETED' ? (
              menuJobStatus ? (
                <JobStatusIndicator
                  status={menuJobStatus.status}
                  progress={menuJobStatus.progress}
                  total={menuJobStatus.total}
                  type="menu"
                  totalSubJobs={menuJobStatus.totalSubJobs}
                  totalSubJobsCompleted={menuJobStatus.totalSubJobsCompleted}
                  totalSubJobsFailed={menuJobStatus.totalSubJobsFailed}
                  totalSubJobsInProgress={menuJobStatus.totalSubJobsInProgress}
                  startedAt={menuJobStatus.startedAt}
                  completedAt={menuJobStatus.completedAt}
                />
              ) : (
                <Typography color='text.secondary'>
                  Waiting for menu publishing to start...
                </Typography>
              )
            ) : (
              <Typography color='text.secondary'>
                Waiting for patch publishing to complete...
              </Typography>
            )}
          </Box>

          <Box sx={{ mb: 3, pr: 3 }}>
            <Typography variant='h6' gutterBottom>
              3. Review Store Menus
            </Typography>
            {!isMenuJobPolling && menuJobStatus?.status === 'COMPLETED' ? (
              <MenuViewer selectedStores={selectedStores} verifyMode />
            ) : (
              <Typography color='text.secondary'>
                Waiting for menu publishing to complete...
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);

export default Step4PublishAndReview; 